import { ACTIONS } from '../types';
import STATUS from '../../../globalStatuses';

export const testProgressReductions = {
  [ACTIONS.REQUEST_TESTPROGTYPE]: state => ({
    ...state,
    testProgTypesStatus: {
      ...state.testProgTypesStatus,
      getStatus: STATUS.FETCHING,
      errorData: null,
    },
  }),
  [ACTIONS.RECEIVE_TESTPROGTYPE]: (state, action) => ({
    ...state,
    testProgTypes: action.payload.testProgTypes,
    testProgTypesStatus: {
      ...state.testProgTypesStatus,
      getStatus: STATUS.FETCHED,
    },
  }),
  [ACTIONS.RECEIVE_TESTPROGTYPE_ERROR]: (state, action) => ({
    ...state,
    error: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
    testProgTypesStatus: {
      ...state.testProgTypesStatus,
      getStatus: STATUS.ERROR,
      errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
    },
  }),
};

export default testProgressReductions;
